export const ROOT_HOOK = 'RouteHook';
export const LOCAL_STATES_CONST = 'localStates';
export const PROP_VALID_TYPE = 'string';
